function parseTermsConditionsData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}
function parseSaveTermsConditionsData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}
function parseLoginTerms(data) {
  if((!data) || data.length==0){
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  const getLoginTerms = ({dummyBrch, metaData}) =>
    api.getLoginTerms(dummyBrch.slice(10), metaData)
    .then(parseLoginTerms);

  const showTermsConditions = ({metaData}) =>
    api.showTermsConditions(metaData)
    .then(parseTermsConditionsData);

  const saveTermsConditions = ({seenTerms, seenPrivacy, channel, termsUrl, privacyUrl, tcVersion, paVersion, metaData}) =>
    api.saveTermsConditions(seenTerms.slice(10), seenPrivacy.slice(10), channel.slice(10), termsUrl.slice(10), privacyUrl.slice(10), tcVersion.slice(10), paVersion.slice(10), metaData)
    .then(parseSaveTermsConditionsData);

  const saveTermsConditionsExtended = ({seenTerms, seenPrivacy, channel, termsUrl, privacyUrl, tcVersion, paVersion, termsChatUrl, seenChatTerms, tcChatVersion, seenSummary, metaData}) =>
    api.saveTermsConditionsExtended(seenTerms.slice(10), seenPrivacy.slice(10), channel.slice(10), termsUrl.slice(10), privacyUrl.slice(10), tcVersion.slice(10), paVersion.slice(10), termsChatUrl.slice(10), seenChatTerms.slice(10), tcChatVersion.slice(10), seenSummary.slice(10), metaData)
    .then(parseSaveTermsConditionsData);

  const getTermsConditionsAndRmiaData = ({metaData}) =>
    api.getTermsConditionsAndRmiaData(metaData)
    .then(parseTermsConditionsData);


    const getPaymentLimit =(({channel,metaData}) =>
    api.getPaymentLimit(channel,metaData).then( (response) => {
      if(!response) return [];
      return JSON.stringify(response);
    }));
    return {
      getLoginTerms,
      showTermsConditions,
      saveTermsConditions,
      getTermsConditionsAndRmiaData,
      saveTermsConditionsExtended,
      getPaymentLimit
    }
}

module.exports = serviceFactory;
